import { Patient } from '../../entities/Patient';
import { api } from '../api';

export const getPatient = async (id: string): Promise<Patient> => {
  const data = await api.get(`/patients/${id}`);

  return data.data.patientData as Patient;
};
